import { FailureMessageCategory } from './types'

export const FAILURE_MESSAGE_CATEGORIES: FailureMessageCategory[] = [
  'USER_DECLINED',
  'BANK_DECLINED',
  'NETWORK_ERROR',
  'APP_NOT_INSTALLED',
  'PAYMENT_PENDING',
  'SESSION_EXPIRED',
]

export const FAILURE_MESSAGE_CATEGORY_LABELS: Record<FailureMessageCategory, string> = {
  USER_DECLINED: 'User Declined',
  BANK_DECLINED: 'Bank Declined',
  NETWORK_ERROR: 'Network Error',
  APP_NOT_INSTALLED: 'App Not Installed',
  PAYMENT_PENDING: 'Payment Pending',
  SESSION_EXPIRED: 'Session Expired',
}

export const FAILURE_MESSAGE_DEFAULTS: Record<
  FailureMessageCategory,
  { image: string; title: string; description: string; ctaText: string }
> = {
  USER_DECLINED: {
    image: '',
    title: 'Payment declined',
    description: 'You declined the payment request.',
    ctaText: 'Try again',
  },
  BANK_DECLINED: {
    image: '',
    title: 'Bank declined payment',
    description: 'Your bank declined this transaction.',
    ctaText: 'Try another method',
  },
  NETWORK_ERROR: {
    image: '',
    title: 'Network error',
    description: 'Please check your internet connection and try again.',
    ctaText: 'Retry',
  },
  APP_NOT_INSTALLED: {
    image: '',
    title: 'UPI app not installed',
    description: 'Please install a UPI app to continue.',
    ctaText: 'Choose another method',
  },
  PAYMENT_PENDING: {
    image: '',
    title: 'Payment pending',
    description: 'Your payment is still being processed.',
    ctaText: 'Check status',
  },
  SESSION_EXPIRED: {
    image: '',
    title: 'Session expired',
    description: 'Your checkout session has expired.',
    ctaText: 'Start again',
  },
}
